import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div
        className="abyss-instrument-frame relative overflow-hidden rounded-xl border border-iron bg-obsidian px-7 py-14 text-frost shadow-[0_32px_90px_rgba(0,0,0,0.28)] md:px-12 md:py-20 lg:px-16 lg:py-24"
        data-calibrated="true"
      >
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="abyss-type-hero"
          tone="dark"
        />
      </div>
    </AbyssSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
